import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './http';
import api from './api';
const _ = require('lodash');
import moment from 'moment';
moment.locale('zh-cn'); //设置语言
// moment.lang('zh-cn'); //设置语言
import gps from './utils/lib/gps'; //GPS坐标转换
import intfilter from './utils/lib/instruct-filter'; //指令权限

import 'amfe-flexible/index.js'; // 自动适配移动端
import {
    Button,
    NavBar,
    Overlay,
    Dialog,
    Slider,
    Toast,
    Popup,
    Icon,
    DatetimePicker,
    Calendar,
    Search,
    Cell,
    Switch,
    image,
    Field,
    Picker,
    ActionSheet,
    RadioGroup,
    Radio,
    Tag,
    DropdownMenu,
    DropdownItem,
    Tab,
    Tabs
} from 'vant';

const components = [Button, NavBar, Overlay, Dialog, Slider, Toast, Popup, Icon, DatetimePicker, Calendar, Search, Cell, Switch, image, Field, Picker, ActionSheet, RadioGroup, Radio, Tag, DropdownMenu, DropdownItem, Tab, Tabs];

components.forEach(component => {
    Vue.use(component);
});

process.env.NODE_ENV != 'production' && require('./mock/index');

Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;
Vue.prototype.$gps = gps;
Vue.prototype.$intfilter = intfilter;
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');